import React, { ElementType, forwardRef, HTMLAttributes } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export interface CCardTitleProps extends HTMLAttributes<HTMLHeadingElement> {
  /**
   * A string of all className you want applied to the component.
   */
  className?: string
  /**
   * Component used for the root node. Either a string to use a HTML element or a component.
   */
  component?: string | ElementType
}

export const CCardTitle = forwardRef<HTMLHeadingElement, CCardTitleProps>(
  ({ children, component: Component = 'h5', className, ...rest }, ref) => {
    return (
      <Component className={classNames('card-title', className)} {...rest} ref={ref}>
        {children}
      </Component>
    )
  },
)

CCardTitle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  component: PropTypes.elementType,
}

CCardTitle.displayName = 'CCardTitle'
